import React, { useState, useEffect, useMemo } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { FaCheck, FaDownload, FaTimes, FaTrash } from 'react-icons/fa';
import { API_URL_All } from '../../api';
import axios from "axios";
import { toast } from "react-toastify";
import * as general from '../../libs/general';
import { CheckingTicket, LockingTicket } from '../tickets/Tickets';
import axiosInstance from '../../axiosInstance';
import ReconciliationPaymentConfirmModal, { buildPaymentSummary } from '../reconciliation/ReconciliationPaymentConfirmModal';

const CheckingReview = ({ data, handleSearch, canEdit = false, canDelete = false, nestedModal = false }) => {
  const [show, setShow] = useState(true);
  const [isLocked, setIsLocked] = useState(true);
  const [model, setModel] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [showPaymentConfirm, setShowPaymentConfirm] = useState(false);

  const toNumber = (value) => {
    const parsedValue = Number(value);
    return Number.isFinite(parsedValue) ? parsedValue : 0;
  };

  const getItemMoneyBeforeVat = (item) => {
    if (item?.moneyBeforeTax != null) {
      return toNumber(item.moneyBeforeTax);
    }

    const goodsMoney = toNumber(item?.money);
    const taxImportMoney = goodsMoney * toNumber(item?.taxImport) / 100;
    const detailedFeeTotal =
      toNumber(item?.feeItem) +
      toNumber(item?.feeEntrust) +
      toNumber(item?.feeNormal) +
      toNumber(item?.feeInsurance) +
      toNumber(item?.feeSurcharge);

    if (detailedFeeTotal > 0) {
      return goodsMoney + taxImportMoney + detailedFeeTotal;
    }

    return goodsMoney + taxImportMoney + toNumber(item?.fee);
  };

  const filteredItems = useMemo(() => {
    const items = Array.isArray(model?.items) ? model.items : [];
    if (data?.lineId == null) return items;
    return items.filter((item) => Number(item?.lineId) === Number(data.lineId));
  }, [model, data?.lineId]);

  const displayedQuantity = useMemo(() => {
    if (data?.lineId == null) return model?.quantity;
    return filteredItems.reduce((total, item) => total + toNumber(item?.quantity), 0);
  }, [data?.lineId, model?.quantity, filteredItems]);

  const displayedInvoiceMoney = useMemo(() => {
    if (data?.money != null) {
      return toNumber(data.money);
    }

    if (data?.lineId == null && model?.money != null) {
      return toNumber(model.money);
    }

    return filteredItems.reduce((total, item) => total + getItemMoneyBeforeVat(item), 0);
  }, [data?.money, data?.lineId, model, filteredItems]);

  useEffect(() => {
    retrieveModalData(data);
  }, [data]);

  const retrieveModalData = async (params) => {
    if (params.id) {
      try {
        var urlApi = `/api/invoices/getInvoice?id=${params.id}`;
        const response = await axiosInstance.get(urlApi);
        var obj = response.data;     
        if (obj.success === false) {
          toast.error(obj.message);
          return;
        }

        setModel(obj.data);
        setShow(true);
      } catch (error) {
        console.error(error);
        setModel({ error: error.message });
        toast.error(error.message);
      }
      return;
    }
    const textIds = params.listIds.join(';');
    setModel({});
    try {
      var urlApi = `/api/invoices/getInvoiceReview?codes=${textIds}`;
      const response = await axiosInstance.get(urlApi);
      var obj = response.data;
      if (obj.success === false) {
        toast.error(obj.message);
        return;
      }

      setModel(obj.data);
      setShow(true);
    } catch (error) {
      console.error(error);
      setModel({ error: error.message });
      toast.error(error.message);
    }
  };


  const handleModalClose = (e) => {
    document.querySelectorAll('.show .error-msg').forEach((item) => {
      if (item.parentNode) {
        item.parentNode.removeChild(item);
      }
    });
    document.activeElement.blur();
    setShow(false);
    if (nestedModal && handleSearch) {
      handleSearch();
    }
  };

  const handleSubmitForm = async(e) => {
    e.preventDefault();
    var errorTag = e.currentTarget.querySelector('.error-msg');
    if (errorTag) return;

    try {
      var requestApi = `/api/invoices/saveInvoice`;
      const response = await axiosInstance.post(requestApi, model);
      if (!response.data.success) {
        general.showFormError('.show .modal-body', response.data);
        console.log(response.data);
        return;
      }
      console.log(response);
      toast.success(response.data.message);
      console.log(response.data);
      if (handleSearch) handleSearch();
      retrieveModalData({ id: response.data.data });
    } catch (error) {
      toast.error(error.message);
    }

  };
  const handleExportInvoice = async (param) => {

    var requestApi = `${API_URL_All}/api/invoices/exportInvoice?id=${param.id}`;
    var fileName = `Invoice_${param.id}.xlsx`;
    if (!param.id) {
      fileName = `Doi_soat_line_vat_preview.xlsx`;
      const avaiableIds = data.listIds;//.filter(id => !removedItems.includes(id));
      const codes = avaiableIds.join(';');
      requestApi = `${API_URL_All}/api/invoices/exportInvoice?codes=${codes}`;
    }

    general.downloadFile(requestApi, fileName);
  };

  const handlePaymentConfirm = () => {
    if (!canEdit) {
      toast.warning("Bạn không có quyền cập nhật đối soát.");
      return;
    }
    setShowPaymentConfirm(true);
  };

  const handlePaymentSuccess = () => {
    if (handleSearch) handleSearch();
    handleModalClose();
  };

  const handleDeletInvoice = (e) => {
    if (!canDelete) {
      toast.warning("Bạn không có quyền xóa hóa đơn.");
      return;
    }
    general.openConfirm(async () => {
      try {
        var requestApi = `/api/invoices/deleteInvoice?id=${model.id}`;
        const response = await axiosInstance.get(requestApi);

        if (!response.data.success) {
          toast.error(response.data.message);
          return;
        }
        toast.success(response.data.message);
        if (handleSearch) handleSearch();
        handleModalClose();

      } catch (error) {
        console.error(error);
        toast.error(error.message);
      }
    })
  };

  return (
    <>
    <Modal
      show={show}
      onHide={handleModalClose}
      size="fullscreen"
      dialogClassName="modal-popupfull checking-review-dialog"
      className={[
        "checking-review-modal",
        nestedModal ? "accounting-nested-modal" : "",
      ].filter(Boolean).join(" ")}
      backdropClassName={nestedModal ? "accounting-nested-modal-backdrop" : undefined}
      enforceFocus={!nestedModal}
    >
      <div className="modal-dialog11 modal-fullscreen11">
        <form id="order_editor_form" className="form_validate normal-form" autoComplete="off" onSubmit={handleSubmitForm}>
          <div className="modal-content">
            <div className="modal-header position-relative flex-between">
              {model.id && (<span className="record_id">ID: {model.id}</span>)}
              <div>
                <h5 className="modal-title">{model.id ? `Chi tiết hóa đơn` : 'Xem trước hóa đơn đối soát'}</h5>
                {model.error && (
                  <div className="error-msg-server">{model.error}</div>
                )}
              </div>
              <button
                type="button"
                className="btn-close"
                onClick={handleModalClose}
                aria-label="Đóng"
              ></button>
            </div>
            <div className="modal-body">

              <div>

                <div className="row mb-2">
                  <div className="col-md-6">
                    <div className="row">
                      <label className="form-label col-md-3">Mã khách hàng: </label>
                      <div className="col-md-9">
                        <b>{model.customerCode}</b>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <label className="form-label col-md-3">Ngày tạo: </label>
                      <div className="col-md-2">
                        <b>{model.createdTimeText}</b>
                      </div>
                      <div className="col-md-7">
                        <CheckingTicket checkingId={model.checkingId} checkingName={model.checkingName} />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mb-2">
                  <div className="col-md-6">
                    <div className="row">
                      <label className="form-label col-md-3">Tên đơn vị: </label>
                      <div className="col-md-9">
                        <b>{model.customerName}</b>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <label className="form-label col-md-3">Email nhận hoá đơn, chứng từ: </label>
                      <div className="col-md-9">
                        <b>{model.customerInvoiceEmail}</b>
                      </div>
                    </div>
                  </div>
                </div>

              <div className="row mb-2">
                <div className="col-md-6">
                  <div className="row">
                      <label className="form-label col-md-3">MST: </label>
                      <div className="col-md-9">
                        <b>{model.taxCode}</b>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                    <div className="row">
                      <label className="form-label col-md-3">Địa chỉ: </label>
                      <div className="col-md-9">
                        <b>{model.customerAddress}</b>
                      </div>
                    </div>
                  </div>
              </div>

                <div className="row mb-2">
                  <div className="col-md-6">
                      <div className="row">
                        <label className="form-label col-md-3">Số lượng SP: </label>
                        <div className="col-md-9">
                          <b>{displayedQuantity}</b>
                        </div>
                      </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <label className="form-label col-md-3"><span title="Tiền hàng + tiền cước">Tổng tiền trước VAT:</span> </label>
                      <div className="col-md-9">
                        <b>{general.formatNumber(displayedInvoiceMoney)} VNĐ</b>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row mb-2'>
                  <div className="col-md-6">
                    <div className="row">
                      {model.id && (
                        <div className="col-md-12">
                          <div className="row pt-2">
                            <label className="form-label col-3">Nội dung: </label>
                            <div className="col-9">
                              <b>{model.name}</b>
                            </div>
                          </div>
                        </div>
                      )}
                      {!model.id && (
                        <div className="col-md-12">
                          <div className="row pt-2">
                            <label className="form-label col-form-label col-3"><span className="required1">Nội dung</span></label>
                            <div className="col-9">
                              <input type="text" className="form-control" placeholder="Nội dung đối soát" data-required1="Phải nhập mục này" autoComplete="off" value={model.name} onChange={(e) => setModel({ ...model, name: e.target.value })} />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

              </div>

              <section className="p-1 ">
                <div className="table-responsive border table-normal table-sticky">
                  <table className="table table-striped border-normal table-bordered">
                    <thead className="table-primary head-01">
                      <tr>
                        <th className='sticky text-center' width="21px">Stt</th>

                        <th className="text-center"><span>Ngày</span></th>
                        <th className="text-center">Mã vận đơn TQ</th>
                        <th className="text-center"><span>Mã SP</span></th>
                        <th>Tên sản phẩm</th>

                        <th className="text-center">Số lượng</th>
                        <th className="text-center"><span data-note="vnđ">Giá khai</span></th>
                        <th className="text-center"><span data-note="vnđ">Thành tiền</span></th>
                        <th className="text-center" colspan="2"><span data-note="vnđ">Thuế NK</span></th>

                        <th className="text-center"><span data-note="vnđ">Phí đ.mục</span></th>
                        <th className="text-center"><span data-note="vnđ">Phí ủy.thác</span></th>
                        <th className="text-center"><span data-note="">KG</span></th>
                        <th className="text-center"><span data-note="">M3</span></th>
                        <th className="text-center"><span data-note="">Cước phí</span></th>

                        <th className="text-center"><span data-note="">Phụ phí</span></th>
                        <th className="text-center"><span data-note="">B.hiểm</span></th>
                        <th className="text-center"><span data-note="vnđ">Tổng trước VAT</span></th>
                        <th className="text-center"><span data-note="%">VAT</span></th>

                        <th>Ghi chú</th>
                      </tr>
                    </thead>
                    {filteredItems.map((item, index) => (
                      <tbody className="tbody-row">
                        <tr key={index}>
                          <td className='sticky text-center' title={`orderId: ${item.id}`}>
                            {index + 1}
                          </td>
                          <td className="text-success text-center" title={item.lineName}>{general.formatDate(item.orderDate)}</td>
                          <td className="text-success text-center">{item.cnCode}</td>
                          <td className='text-success text-center' title={`orderId: ${item.orderId}`}>{item.productCode}</td>
                          <td className="text-success text-start">{item.productName}</td>

                          <td className="text-success text-center">{item.quantity}</td>
                          <td className="text-success text-center">{general.formatNumber(item.priceDeclare)}</td>
                          <td className="text-success text-center">{general.formatNumber(item.money)}</td>
                          <td className="text-success text-center">{general.formatNumber(item.taxImport)}%</td>
                          <td className="text-success text-center">{general.formatNumber(Math.round(item.priceDeclare * item.quantity * item.taxImport / 100))}</td>

                          <td className="text-success text-center">{general.formatNumber(item.feeItem)}</td>
                          <td className="text-success text-center">{general.formatNumber(item.feeEntrust)}</td>
                          <td className="text-success text-center">{general.formatNumber(item.weight)}</td>
                          <td className="text-success text-center">{general.formatDecimal(item.size)}</td>
                          <td className="text-success text-center">{general.formatNumber(item.feeNormal)}</td>

                          <td className="text-success text-center">{general.formatNumber(item.feeSurcharge)}</td>
                          <td className="text-success text-center">{general.formatNumber(item.priceInsurance)}</td>
                          <td className="text-success text-center">{general.formatNumber(getItemMoneyBeforeVat(item))}</td>
                          <td className="text-success text-center">{general.formatNumber(item.taxVat)}</td>

                          <td className="text-start text-truncate mw-101" title={item.note}>{item.note}</td>

                        </tr>
                      </tbody>
                    ))}


                    <tbody>
                      {errorMessage === '' && loaded && filteredItems.length === 0 && (
                        <tr>
                          <td colSpan="21" className="text-center">Không tìm thấy dữ liệu</td>
                        </tr>
                      )}
                      {errorMessage !== '' && (
                        <tr>
                          <td colSpan="21" className="text-center">{errorMessage}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </section>








            </div>
            <div className="modal-footer text-end">
              {!model.id && (
                <div className="flex-between w-100">
                  <div><span className="btn-sm btn btn-primary me-2 d-inline-flex align-items-center gap-1" onClick={(e) => handleExportInvoice({ codes: model.codes })}><FaDownload size={12} /> Xuất excel nháp</span>
                  </div>
                  <div>
                    <button type="submit" className="btn-sm btn btn-primary d-inline-flex align-items-center gap-1"><FaCheck size={12} /> Xác nhận đối soát</button>
                  </div>
                </div>
              )}
              {model.id && (
                <div className="flex-between w-100">
                  <div className="d-flex align-items-center">
                    <span className="btn-sm btn btn-primary me-2 d-inline-flex align-items-center gap-1" onClick={(e) => handleExportInvoice({ id: model.id })}><FaDownload size={12} /> Xuất excel</span>
                    {canDelete && (
                      <button type="button" className="btn-small d-inline-flex align-items-center gap-1" onClick={() => handleDeletInvoice()} ><FaTrash size={12} /> Xóa</button>
                    )}
                  </div>
                  <div>
                    {model.checkingId === 14 && canEdit && (
                      <span className="btn-sm btn btn-primary me-2 d-inline-flex align-items-center gap-1" onClick={() => handlePaymentConfirm()}><FaCheck size={12} /> Xác nhận thanh toán</span>
                    )}
                    <button onClick={(e) => { handleModalClose() }} type="button" className="btn-sm btn btn-secondary d-inline-flex align-items-center gap-1"><FaTimes size={12} /> Đóng</button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </form>
      </div>
    </Modal>
    <ReconciliationPaymentConfirmModal
      show={showPaymentConfirm}
      onHide={() => setShowPaymentConfirm(false)}
      onSuccess={handlePaymentSuccess}
      completeApi="/api/invoices/completeInvoice"
      payloadBase={model}
      summary={buildPaymentSummary(model, "customer")}
      accountLabel="Tài khoản nhận tiền"
    />
    </>
  );
};

export default CheckingReview;
